<template>
    <Modal
        :show="showModal"
        :title="modalTitle"
        size="extralarge"
        :needFooter="false"
        :needHeader="true"
        :centered="true"
        :closeBtn="true"
        @close="onClose"
        modalClass=""
        bodyClass=""
        class="cemetery-advanced-search"
    >
        <form
            autocomplete="off"
            method="get"
            :data-vv-scope="vScope"
            @keyup.enter="
                () => {
                    return false;
                }
            "
            @submit.prevent="
                () => {
                    return false;
                }
            "
        >
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-cemetery_id"
                            name="cemetery_id"
                            label="name"
                            v-model.trim="form.cemetery_id"
                            :options="cemeteries"
                            :multiple="true"
                            v-validate="'required'"
                            :data-vv-scope="vScope"
                            :inputClasses="[{ 'is-invalid': fnHasError('cemetery_id', vScope) }]"
                            :error="fnFirstError('cemetery_id', vScope)"
                        >
                            {{ $t(`${translateID}.cemetery.title`) }}
                        </MaterialSelect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12">
                            <ElementAdvancedSearch
                                elementName="Occupation"
                                v-model="form"
                                :panelCfg="panel"
                                baseTranslateID="occupations"
                                :readonlyForm="readonlyForm"
                                :vScope="vScope"
                                :lists="lists"
                                :expanded="false"
                            />
                        </div>
                        <div class="col-12">
                            <ElementAdvancedSearch
                                elementName="DeedOwner"
                                v-model="form"
                                :panelCfg="panel"
                                baseTranslateID="deed_owners"
                                :readonlyForm="readonlyForm"
                                :vScope="vScope"
                                :lists="lists"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12">
                            <ElementAdvancedSearch
                                elementName="Interment"
                                v-model="form"
                                :panelCfg="panel"
                                baseTranslateID="interments"
                                :readonlyForm="readonlyForm"
                                :vScope="vScope"
                                :lists="lists"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <template v-slot:modal-footer>
            <div class="modal-footer border-0">
                <div class="row no-gutters w-100 m-0 justify-content-between">
                    <div class="col-12 col-sm-auto">
                        <button
                            class="btn btn-rounded btn-sm btn-responsive btn-outline-main min-w-auto"
                            type="button"
                            @click.prevent="onClearForm"
                        >
                            {{ $t(`${translateID}.buttons.clear`) }}
                        </button>
                    </div>
                    <div class="col-12 col-sm-auto">
                        <div class="row">
                            <div class="col-12 col-sm-auto">
                                <button
                                    class="btn btn-rounded btn-sm btn-responsive btn-outline-main min-w-auto"
                                    type="button"
                                    @click.prevent="onCancel"
                                >
                                    {{ $t(`${translateID}.buttons.cancel`) }}
                                </button>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <button
                                    class="btn btn-rounded btn-sm btn-responsive btn-main min-w-auto"
                                    type="button"
                                    @click.prevent="onSearch"
                                >
                                    {{ $t(`${translateID}.buttons.search`) }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import ComponentMixin from "../../shared/mixins/ComponentMixin";
import { EVENTS } from "../../shared/config";
import { formatUrl, encodeUrlParams } from "@config/utils";

export default {
    mixins: [ComponentMixin],
    components: {
        Modal: () => import(/* webpackChunkName: "modal" */ "@/app/shared/components/modals/Modal"),
        ElementAdvancedSearch: () => import(/* webpackChunkName: "cemeteries-searchelementadvanced" */ "./elements/ElementAdvancedSearch.vue")
    },
    provide() {
        return { parentValidator: this.$validator };
    },
    props: {
        moduleCode: {
            type: String,
            require: true,
            default: null
        }
    },
    data() {
        let idPanel = "navsearch_advanced";
        return {
            idPanel: idPanel,
            baseTranslateID: idPanel,
            showModal: false,
            vScope: "form",
            readonlyForm: false,
            form: {
                cemetery_id: null,
                occupation: {
                    code: null,
                    sector: null,
                    number: null,
                    occupation_type_id: null,
                    occupation_state_type_id: null,
                    burials_capacity: null,
                    entombment_capacity: null,
                    cremation_capacity: null,
                    interments: {
                        from_qty: null,
                        to_qty: null
                    }
                },
                interment: {
                    number: null,
                    interment_at: null,
                    entity: {
                        name: null,
                        birth_at: null,
                        death_at: null,
                        age: {
                            from: null,
                            to: null
                        }
                    }
                },
                deed_owner: {
                    application_at: null,
                    expiry_at: null,
                    occupation_right_type_id: null,
                    occupation_term_right_type_id: null,
                    fee: {
                        from: null,
                        to: null
                    }
                }
            },
            lists: {
                loaded: false,
                cemeteries: [],
                occupation_types: [],
                occupation_states: [],
                occupation_right_types: [],
                occupation_term_right_types: []
            }
        };
    },
    created() {
        this.$eventBus.listen(this.moduleCode, EVENTS.SHOW_ADVANCED_SEARCH, this.openModal);
        this.$eventBus.listen(this.moduleCode, EVENTS.CLOSE_ADVANCED_SEARCH, this.closeModal);
    },
    mounted() {},
    beforeDestroy() {
        this.$eventBus.remove(this.moduleCode, EVENTS.SHOW_ADVANCED_SEARCH, this.openModal);
        this.$eventBus.remove(this.moduleCode, EVENTS.CLOSE_ADVANCED_SEARCH, this.closeModal);
    },
    computed: {
        translateID() {
            return `${this.baseTranslateID}`;
        },
        modalTitle() {
            // Advanced Search
            // Only available for cemeteries with published records
            return this.$t(`${this.translateID}.title`);
        },
        cemeteries() {
            return this.lists.cemeteries;
        }
    },
    methods: {
        openModal(params = {}) {
            // this.reset();
            this.loadLists().then(res => {
                this.setVisibilityModal(!!res);
            });
        },
        closeModal() {
            this.setVisibilityModal(false);
        },
        onClose() {
            this.closeModal();
        },
        onClearForm() {
            this.reset();
        },
        onCancel() {
            this.onClose();
        },
        setVisibilityModal(flag) {
            this.showModal = flag;
        },
        reset() {
            Object.assign(this.$data.form, this.$options.data().form);
            this.resetValidator();
        },
        async loadLists() {
            let url = this.url.lists;
            if (!url) {
                return Promise.resolve(false);
            }

            if (!this.lists.loaded) {
                return await this.$http
                    .get(formatUrl(url, { id: this.form.id }))
                    .then(({ data }) => {
                        Object.keys(data).forEach(key => {
                            if (key in this.lists) {
                                this.lists[key] = data[key];
                            }
                        });
                        this.lists.loaded = true;
                        return true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                        return false;
                    });
            } else {
                return Promise.resolve(true);
            }
        },
        async onSearch() {
            this.clearMessages();

            return this.$validator.validateAll("form").then(result => {
                if (!result) {
                    this.showError(this.$t("global.msg.error.form"), this.modalTitle);
                    return Promise.resolve(false);
                }

                let url = this.url.search;
                if (url) {
                    return this.$http
                        .get(encodeUrlParams(formatUrl(url, { data: JSON.stringify(this.form) }), "data"))
                        .then(res => {

                            console.log("onSearch", res);
                            console.log("this.form", this.form);

                            this.publishEventListen("cem", "map.reload");
                            this.$eventBus.publish(this.moduleCode, "map.reload", {
                                queryParams: {
                                    id: "ccc"
                                }
                            });
                           // this.closeModal();
                        })
                        .catch(error => {
                            this.showHttpError(error);
                        });
                }
                return Promise.resolve(false);
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
